import React from 'react';
import styles from './Form.module.scss';

import { FormLabel, FormRow, FormSelectInput } from 'components/FormComponents';
import FormInputText from 'components/FormComponents/FormInputText/FormInputText_v2';
import FormTextArea from 'components/FormComponents/FormTextArea/FormTextArea_v2';
import DetailedRow from 'components/DetailsComponents/DetailedRow';

import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useMobileViewport } from 'hooks/useMobileViewport';

import { dateTimeFormat, formatDate } from 'helpers/AppHelpers';

import clsx from 'clsx';

import { FORM_FIELDS } from '../../helpers';

export function Form({ creationForm = {} }) {
  const isMobile = useMobileViewport();

  const { id } = useParams();
  const { setValue, getValues } = useFormContext();

  const isEditScreen = Boolean(id);

  const { priorities = [], severities = [] } = creationForm;

  const selectOption = ({ name, value }) => setValue(name, value);

  return (
    <div className={styles.form}>
      <div className={styles.form__block}>
        <FormRow>
          <FormLabel required>Job number</FormLabel>
          <FormInputText name={FORM_FIELDS.JOB_NUMBER} options={{ max: 255 }} />
        </FormRow>

        <FormRow>
          <FormLabel required>Job location</FormLabel>
          <FormInputText name={FORM_FIELDS.JOB_LOCATION} options={{ max: 255 }} />
        </FormRow>

        <FormRow>
          <FormLabel required>Priority</FormLabel>
          <FormSelectInput
            name={FORM_FIELDS.PRIORITY}
            options={priorities}
            onSelect={selectOption}
          />
        </FormRow>

        <FormRow>
          <FormLabel required>Severity</FormLabel>
          <FormSelectInput
            name={FORM_FIELDS.SEVERITY}
            options={severities}
            onSelect={selectOption}
          />
        </FormRow>

        <FormRow>
          <FormLabel required>Task location</FormLabel>
          <FormInputText name={FORM_FIELDS.TASK_LOCATION} options={{ max: 255 }} />
        </FormRow>

        {!isEditScreen && (
          <FormRow>
            <FormLabel>Requester phone #</FormLabel>
            <FormInputText name={FORM_FIELDS.REQUESTER_PHONE} options={{ max: 20 }} />
          </FormRow>
        )}

        <FormRow type="column">
          <FormLabel required>Work order task request</FormLabel>
          <FormTextArea name={FORM_FIELDS.WORK_ORDER_TASK_REQUEST} options={{ max: 10_000 }} />
        </FormRow>

        {isEditScreen && (
          <FormRow type="column">
            <FormLabel required>Comments</FormLabel>
            <FormTextArea name={FORM_FIELDS.COMMENT} options={{ max: 10_000 }} />
          </FormRow>
        )}
      </div>

      {isEditScreen && (
        <div className={clsx(styles.form__block, styles.info)}>
          <DetailedRow
            alignCenter={!isMobile}
            label="Requester name"
            value={getValues(FORM_FIELDS.REQUESTER_NAME)}
          />
          <DetailedRow
            alignCenter={!isMobile}
            label="Requester email"
            value={getValues(FORM_FIELDS.REQUESTER_EMAIL)}
          />
          <DetailedRow
            alignCenter={!isMobile}
            label="Requester phone #"
            value={getValues(FORM_FIELDS.REQUESTER_PHONE)}
          />
          <DetailedRow
            alignCenter={!isMobile}
            label="Opened On"
            value={formatDate(getValues(FORM_FIELDS.OPENED_ON), dateTimeFormat)}
          />
        </div>
      )}
    </div>
  );
}
